// extracted by mini-css-extract-plugin
export default {"myButton":"my-button-with-border_myButton__kK1VZ"};